import { AxiosPost, AxiosGet } from "../AxiosWrapper";
import { MANAGEMENT_SERVICE_URL } from "../../constants/ServiceUrls";

export const getUsers = () => {
  return AxiosPost(`${MANAGEMENT_SERVICE_URL}api/User/GetUsers`, {});
};

export const upsertUser = (user) => {
  return AxiosPost(`${MANAGEMENT_SERVICE_URL}api/user/InsertUser`, user);
};

export const UpdateUser = (user) => {
  return AxiosPost(`${MANAGEMENT_SERVICE_URL}api/user/UpdateUser`, user);
};

export const deleteUser = (id) => {
  return AxiosPost(`${MANAGEMENT_SERVICE_URL}api/user/DeleteUser`, {
    userId: id,
  });
};
export const changePassword = (params) => {
  return AxiosPost(`${MANAGEMENT_SERVICE_URL}api/user/ChangePassword`, {
    ...params,
  });
};

export const getDocumentTypeGrantsForUser = (userId) => {
  return AxiosPost(
    `${MANAGEMENT_SERVICE_URL}api/User/GetDocumentTypeGrantsForUser`,
    {
      userId,
    }
  );
};

export const getFolderGrantsForUser = (userId) => {
  return AxiosPost(`${MANAGEMENT_SERVICE_URL}api/User/GetFolderGrantsForUser`, {
    userId,
  });
};

export const grantDocumentTypeToUser = (grantDocumentTypeToUserParameters) => {
  return AxiosPost(
    `${MANAGEMENT_SERVICE_URL}api/User/GrantDocumentTypeToUser`,
    grantDocumentTypeToUserParameters
  );
};

export const grantFolderToUser = (grantFolderToUserParameters) => {
  return AxiosPost(
    `${MANAGEMENT_SERVICE_URL}api/User/grantFolderToUser`,
    grantFolderToUserParameters
  );
};
export const grantRoleToUser = (grantRolesToUserParameters) => {
  return AxiosPost(
    `${MANAGEMENT_SERVICE_URL}api/User/GrantRoleToUser`,
    grantRolesToUserParameters
  );
};

export const removeUserRoleGrant = (removeUserRoleGrantParameters) => {
  return AxiosPost(
    `${MANAGEMENT_SERVICE_URL}api/User/RemoveUserRoleGrant`,
    removeUserRoleGrantParameters
  );
};

export const getAssignedRolesForUser = (userId) => {
  return AxiosPost(
    `${MANAGEMENT_SERVICE_URL}api/User/GetAssignedRolesForUser`,
    { userId }
  );
};

export const getAssignedClientsForUser = () => {
  return AxiosGet(
    `${MANAGEMENT_SERVICE_URL}api/User/GetAssignedClientsForUser`
  );
};

export const getAssignedRolesForAuthorisation = () => {
  return AxiosGet(
    `${MANAGEMENT_SERVICE_URL}api/User/GetAssignedRolesForAuthorisation`
  );
};

export const reset2FAConfig = (userId) => {
  return AxiosPost(
    `${MANAGEMENT_SERVICE_URL}api/User/ResetOneTimePasswordConfigurationForUser`,
    userId
  );
};

export const downloadUserDetails = () => {
  return AxiosGet(
    `${MANAGEMENT_SERVICE_URL}
api/User/DownloadUserDetail`,
    { responseType: "blob" }
  );
};

export default {
  getUsers,
  upsertUser,
  deleteUser,
  changePassword,
  getDocumentTypeGrantsForUser,
  getFolderGrantsForUser,
  grantDocumentTypeToUser,
  grantRoleToUser,
  removeUserRoleGrant,
  getAssignedRolesForAuthorisation,
  getAssignedClientsForUser,
  downloadUserDetails,
};
